import makeActionCreator from './makeActionCreator';
import {
  SEND_TEST_EMAIL_DELIVERY,
  SEND_TEST_EMAIL_DELIVERY_DONE,
  SEND_TEST_EMAIL_DELIVERY_ERROR,
  SEND_TEST_EMAIL_DELIVERY_LOADING,
  SEND_TEST_EMAIL_DELIVERY_SUCCESS
} from './actionTypes';

// Create your Action Creators here...
export const sendTestEmailDelivery = makeActionCreator(SEND_TEST_EMAIL_DELIVERY, 'tenantId',
  'emails');
export const sendTestEmailDeliveryLoading = makeActionCreator(SEND_TEST_EMAIL_DELIVERY_LOADING);
export const sendTestEmailDeliverySuccess = makeActionCreator(SEND_TEST_EMAIL_DELIVERY_SUCCESS,
  'emails');
export const sendTestEmailDeliveryError = makeActionCreator(SEND_TEST_EMAIL_DELIVERY_ERROR,
  'error');
export const sendTestEmailDeliveryDone = makeActionCreator(SEND_TEST_EMAIL_DELIVERY_DONE);
